/**
 * FilterContainer component
 * @returns <FIlterContainer />
 */

const FilterContainer = ({ title, children }) => {
    return (
        <div className="filter-container">
            <p className="filter-container__title">{title}</p>

            <div className="filter-container__wrapper">
                {children}
            </div>
        </div>
    )
}

export default FilterContainer